function AppDetailPage({ activeApp }) {
  if (!activeApp) {
    return (
      <section className="section app-detail">
        <div className="empty-state">
          <h2>We cannot find that app yet.</h2>
          <p>Head back to the studio overview.</p>
          <a className="btn primary" href="#/apps">
            Browse apps
          </a>
        </div>
      </section>
    );
  }

  return (
    <section className="section app-detail">
      <div className="detail-hero reveal" style={{ '--delay': '0ms' }}>
        <div className="detail-hero-main">
          <h1 className="detail-title">
            <img
              className="detail-icon"
              src={activeApp.logo}
              alt={`${activeApp.name} app icon`}
            />
            {activeApp.name}
          </h1>
          <p className="lede">{activeApp.tagline}</p>
          <p className="detail-summary">{activeApp.summary}</p>
        </div>
        <div className="detail-hero-side">
          <div className="detail-download-badges">
            {activeApp.storeLinks.appStore && (
              <a
                className="download-badge-link"
                href={activeApp.storeLinks.appStore}
                target="_blank"
                rel="noreferrer"
                aria-label="Download on the App Store"
              >
                <img
                  className="download-badge"
                  src={`${process.env.PUBLIC_URL}/DownloadBadgeAppStore.svg`}
                  alt="Download on the App Store"
                />
              </a>
            )}
            {activeApp.storeLinks.googlePlay && (
              <a
                className="download-badge-link"
                href={activeApp.storeLinks.googlePlay}
                target="_blank"
                rel="noreferrer"
                aria-label="Get it on Google Play"
              >
                <img
                  className="download-badge"
                  src={`${process.env.PUBLIC_URL}/DownloadBadgeGooglePlay.png`}
                  alt="Get it on Google Play"
                />
              </a>
            )}
            {activeApp.storeLinks.webApp && activeApp.slug !== '12Pack' && (
              <a
                className="web-app-badge"
                href={activeApp.storeLinks.webApp}
                target="_blank"
                rel="noreferrer"
                aria-label="Open Web App"
              >
                <svg className="web-app-badge-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2a10 10 0 1 0 0 20A10 10 0 0 0 12 2zm-1 17.93V18a1 1 0 0 0-1-1H8a3 3 0 0 1-3-3v-1l5 5v.93zM17.9 15.4 13 10.5V8a1 1 0 0 0-2 0v3a1 1 0 0 0 .29.71l5.3 5.29a8 8 0 0 1-9.52.4L11 13.41V11a1 1 0 0 0-2 0v3a1 1 0 0 0 .29.71l-3.65 3.65A8 8 0 0 1 4 12c0-4.07 3.06-7.44 7-7.93V6a1 1 0 0 0 2 0V4.07A8.01 8.01 0 0 1 20 12a7.95 7.95 0 0 1-2.1 5.4z"/>
                </svg>
                <div className="web-app-badge-text">
                  <span className="web-app-badge-sub">Launch in browser</span>
                  <span className="web-app-badge-main">Open Web App</span>
                </div>
              </a>
            )}
          </div>
        </div>
      </div>
      {activeApp.slug === '12Pack' && (
        <div className="app-animation-wrapper">
          <iframe
            className="app-animation"
            src={`${process.env.PUBLIC_URL}/12Pack/12pack-animation.html`}
            title="12Pack animated commercial"
            allowFullScreen
          />
        </div>
      )}
      <div className="detail-grid">
        {activeApp.story && (
          <div className="detail-card reveal" style={{ '--delay': '120ms' }}>
            <h3>{activeApp.name}</h3>
            <p>{activeApp.story}</p>
          </div>
        )}
        {activeApp.features.length > 0 && (
          <div className="detail-card reveal" style={{ '--delay': '360ms' }}>
            <h3>Feature set</h3>
            <ul>
              {activeApp.features.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        )}
        {activeApp.screenshots.length > 0 && (
          <div className="detail-card wide-card reveal" style={{ '--delay': '360ms' }}>
            <h3>App print screens</h3>
            <div className="screenshot-grid">
              {activeApp.screenshots.map((shot) => (
                <img
                  key={shot.src}
                  className="screenshot"
                  src={`${process.env.PUBLIC_URL}/${shot.src}`}
                  alt={shot.alt}
                />
              ))}
            </div>
          </div>
        )}
        {activeApp.privacy && (
          <div className="detail-card reveal" style={{ '--delay': '360ms' }}>
            <h3>Which personal data do we store?</h3>
            <p>In order to create your account, we store following data:</p>
            <ul>
              {activeApp.privacy.dataStored.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>{activeApp.privacy.storage}</p>
            <p>{activeApp.privacy.services}</p>
          </div>
        )}
        {activeApp.accountDeletion.length > 0 && (
          <div className="detail-card reveal" style={{ '--delay': '360ms' }}>
            <h3>Suppress your account</h3>
            <p>To suppress your account, follow the following steps:</p>
            <ul>
              {activeApp.accountDeletion.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
}

export default AppDetailPage;
